import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthCard } from "@/components/ax/AuthCard";
import { Button } from "@/components/ax/Button";
import { Field } from "@/components/ax/Field";
import { useI18n } from "@/i18n";
import { register } from "@/lib/mockAuth";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function Daftar() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  const refs = { name: useRef(null), email: useRef(null), password: useRef(null) };

  useEffect(() => refs.name.current?.focus(), []); // eslint-disable-line react-hooks/exhaustive-deps

  const set = (k) => (e) => {
    setForm((f) => ({ ...f, [k]: e.target.value }));
    setErrors((x) => ({ ...x, [k]: undefined }));
  };

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    const next = {};
    if (form.name.trim().length < 2) next.name = t("err.name");
    if (!EMAIL_RE.test(form.email.trim())) next.email = t("err.email");
    if (form.password.length < 8) next.password = t("err.password.min");
    if (Object.keys(next).length) {
      setErrors(next);
      refs[Object.keys(next)[0]].current?.focus();
      return;
    }
    setBusy(true);
    let res;
    try { res = await register(form); }
    catch { res = { error: "registration" }; }
    finally { setBusy(false); }
    if (res?.error === "exists") {
      setErrors({ email: t("err.exists"), exists: true });
      refs.email.current?.focus();
    } else if (res?.ok === true) navigate("/verifikasi-email");
    else setErrors({ submit: t(res?.accountCreated ? "err.registerPartial" : "err.register") });
  };

  return (
    <AuthCard title={t("auth.register.title")} testId="daftar-page">
      <p className="mt-2 text-sm leading-6 text-ax-muted" data-testid="register-trial-note">{t("auth.register.trialNote")}</p>
      <form onSubmit={submit} noValidate className="mt-4">
        <Field
          ref={refs.name}
          label={t("field.name")}
          name="name"
          autoComplete="name"
          maxLength={60}
          value={form.name}
          onChange={set("name")}
          error={errors.name}
          testId="register-name-input"
        />
        <Field
          ref={refs.email}
          className="mt-4"
          label={t("field.email")}
          type="email"
          name="email"
          autoComplete="email"
          maxLength={120}
          value={form.email}
          onChange={set("email")}
          error={errors.email}
          testId="register-email-input"
        />
        <Field
          ref={refs.password}
          className="mt-4"
          label={t("field.password")}
          type="password"
          name="password"
          autoComplete="new-password"
          hint={t("auth.register.passwordHint")}
          maxLength={72}
          value={form.password}
          onChange={set("password")}
          error={errors.password}
          testId="register-password-input"
        />
        <Button
          type="submit"
          variant="primary"
          busy={busy}
          disabled={busy}
          data-testid="register-submit-button"
          className="mt-6 w-full"
        >
          {busy ? t("auth.register.busy") : t("auth.register.submit")}
        </Button>
      </form>
      {errors.submit && <p role="alert" data-testid="register-error" className="mt-4 text-sm leading-5 text-ax-error">{errors.submit}</p>}
      <div className="mt-4">
        <Link
          to="/masuk"
          data-testid="signin-link"
          className="inline-flex min-h-[48px] items-center text-sm font-medium text-ax-link hover:underline"
        >
          {t("auth.register.signin")}
        </Link>
      </div>
    </AuthCard>
  );
}
